import React from 'react';

import {translate} from 'iss/strings';
import {Field} from 'iss/widgets/Forms';
import {ProfitCenterSelector} from 'iss/widgets/Selectors';
import {siteNameColumn} from 'iss/widgets/activation/SelectableContractEditor';
import {Table} from 'iss/widgets/bootstrap/Table';

const profitCenterSelectorColumn =  {
  header: translate("evaluationActivator.profitCenter"),
  accessor: (contract) =>
  <ProfitCenterSelector valuePath={["profitCenters", contract.id]} contractExtId={contract.externalId}/>
};

export function MultiProfitCenterSelector() {
  return <Field valuePath="contracts">
    {(contracts) =>
        <Table id="profitCenters" data={contracts.getValue()}
          columns={[siteNameColumn, profitCenterSelectorColumn]} />
    }
  </Field>;
}



// WEBPACK FOOTER //
// ./modules/issFrontend/widgets/activation/MultiProfitCenterSelector.jsx